import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
// components
import BasicLoader from 'refactored/features/emergencies/ui/loaders/basic-loader';
import { LoadMoreButton } from 'refactored/features/emergencies/ui/buttons/load-more-button';
import useScrollCache from 'refactored/features/emergencies/context/use-scroll-cache';
import { groupTicketsByDate } from 'refactored/features/emergencies/utils/date-utils';
import FixedWithContainer from 'refactored/features/emergencies/ui/containers/fixed-with-container';
import Sticky from 'refactored/features/emergencies/ui/sticky/sticky';
import NonSticky from 'refactored/features/emergencies/ui/sticky/non-sticky';
import TicketsListTableHeaderRow from './rows/tickets-list-table-header-row';
import TicketsListTableDateRow from './rows/tickets-list-table-date-row';
import TicketsListTableTicketRow from './rows/tickets-list-table-ticket-row';

const InfiniteLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  ${LoadMoreButton} {
    width: 200px;
  }
  ${BasicLoader} {
  }
`;
const LoaderContainer = styled.div`
  padding-top: 16px;
`;

const ObservableContainer = ({ onObserv, children }) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin: '' }
    );
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [isIntersecting]);

  useEffect(() => {
    if (isIntersecting) {
      onObserv();
    }
  }, [isIntersecting, onObserv]);
  return <div ref={ref}>{children}</div>;
};

const TicketsListTable = ({ ticketsListData }) => {
  const {
    manuallyScrollToElementRef,
    scrollToSavedCache,
    saveCurrentPositionToCache,
  } = useScrollCache();

  useEffect(() => {
    scrollToSavedCache();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const tickets = ticketsListData.ungroupedTickets.flat();
  const ticketsGrouped = groupTicketsByDate({ items: tickets });
  const { isEmpty, isReachingEnd, isLoadingMore, reset } = ticketsListData;

  return (
    <>
      <FixedWithContainer
        onScroll={saveCurrentPositionToCache}
        ref={manuallyScrollToElementRef}
      >
        <Sticky>
          <TicketsListTableHeaderRow />
        </Sticky>
        <NonSticky>
          {ticketsGrouped.map((ticketsGroupedByDay, index) => (
            <>
              <TicketsListTableDateRow
                key={index}
                ticketsGroupedByDay={ticketsGroupedByDay}
              />
              {ticketsGroupedByDay.tickets.map((ticket) => (
                <TicketsListTableTicketRow
                  key={ticket.id}
                  ticket={ticket}
                  reset={reset}
                />
              ))}
            </>
          ))}
          <InfiniteLoaderContainer>
            {isLoadingMore ? (
              <LoaderContainer>
                <BasicLoader size={10} />
              </LoaderContainer>
            ) : (
              <>
                {!isEmpty && !isReachingEnd && (
                  <ObservableContainer onObserv={ticketsListData.loadMore}>
                    <LoaderContainer>
                      <BasicLoader size={10} />
                    </LoaderContainer>
                  </ObservableContainer>
                )}
              </>
            )}
          </InfiniteLoaderContainer>
        </NonSticky>
      </FixedWithContainer>
    </>
  );
};

export default TicketsListTable;
